import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Ora Cacao's "Tantric Rose Blossom Cacao -
// Organic Ceremonial Chocolate" (p_5lr5ynx4gy), pulled from Faire's live
// `GET /api/product-reviews/product/{product_token}` endpoint — verbatim
// comment, real reviewer, real rating, real publish date.
export const review_oc3: FaireReviewEntity = {
  token: "review_oc3",
  type: "review",
  brandName: "Ora Cacao",
  brandToken: "b_djuc44eyt2",
  productToken: "p_5lr5ynx4gy",
  reviewType: "product",
  reviewerName: "Sotantar Anderson",
  reviewerLocation: "Carbondale, CO, United States",
  stars: 5,
  reviewText:
    "Unique blend of cacao. Exquisitely crafted and something you won’t forget.",
  reviewDate: "Aug 6, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-08-11T20:50:10.000Z",
    importedBy: "entity-db-cli",
  },
};
